export enum SidebarType {
  MENU = "menu",
  SETTINGS = "settings",
}
